import { createUseStyles } from 'react-jss';
import { PricingAppTheme } from '~app/styles/pricing/types';
import { pricingElevation } from '~app/styles/theme';
import { BETWEEN_MD_LG_MEDIA_QUERY, LG_MEDIA_QUERY } from '~shared/media-query';

export default createUseStyles(({ spacing, type, pricingPalette }: PricingAppTheme) => ({
  Shadow: {
    boxShadow: `0px 2px 8px 0px rgba(0, 0, 0, 0.16)`,
  },
  Switch: {
    fontSize: type.fontSize.body,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: spacing[1],
    margin: [0, 'auto', spacing[4]],
    lineHeight: 1.5,
    color: pricingPalette.colors.slate,
    backgroundColor: pricingPalette.colors.pebble,
    borderRadius: 50,
    maxWidth: 300,

    [LG_MEDIA_QUERY]: {
      marginBottom: 0,
    },

    '& input': {
      opacity: 0,
      width: 0,
      height: 0,
      position: 'absolute',
    },
  },
  Values: {
    width: '100%',
    minHeight: 36,
    borderRadius: 50,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    position: 'relative',
    cursor: 'pointer',

    [BETWEEN_MD_LG_MEDIA_QUERY]: {
      fontSize: '.75em',
    },

    '& span': {
      textAlign: 'center',
      zIndex: pricingElevation.plusOne,
      transition: 'all ease-out .3s',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: [0, '5%'],
      borderRadius: 50,
      flexWrap: 'wrap',
      '&:first-child': {
        fontWeight: type.fontWeight.medium,
        backgroundColor: pricingPalette.colors.white,
        extend: 'Shadow',
      },
      '& strong': {
        paddingLeft: 5,
        fontWeight: 'normal !important',
      },
    },
  },

  Checked: {
    '& span:first-child': {
      backgroundColor: 'transparent',
      fontWeight: 'normal',
      boxShadow: 'none',
    },
    '& span:last-child': {
      backgroundColor: pricingPalette.colors.white,
      fontWeight: type.fontWeight.medium,
      extend: 'Shadow',

      '& strong': {
        color: pricingPalette.colors.sabaeus,
        fontWeight: `${type.fontWeight.medium} !important`,
      },
    },
  },
}));
